// 匿名コンサルホットライン クライアント側のテキスト定数
import { isSameDay } from '@/utils/libs/date-fns/compare';
import { formatToString } from '@/utils/libs/date-fns/format';
export const hotlineClientText = {
    /**
     * ボタン文言
     */
    action: {
        contact: () => '今後の進め方を相談',
        reorder: () => 'もう一度相談する',
    },
    /**
     * 料金のお支払いについて
     */
    chargePayment: () => [
        'どの会社に所属するコンサルタントとWeb会議でご相談頂いても料金は一時間あたり一律10万円（税抜き）です。',
        '相談実施日の翌営業日に、お申込みいただいた方が所属する企業宛にPROFFITより請求書をお送りいたします。\n※送付元はPROFFITを運営する合同会社Co-nnect Inc.となります。',
        'お支払い期限は請求書送付日の翌月末までです。',
    ],
    /**
     * 今後のスケジュールの説明文言
     */
    futureSchedule: (requestDeadlineAt, interviewRequestedFromAt, interviewRequestedToAt) => {
        const formatString = 'MM月dd日';
        const from = new Date(interviewRequestedFromAt);
        const to = new Date(interviewRequestedToAt);
        const interviewRequestedAt = isSameDay(from, to)
            ? formatToString({ formatString, value: from })
            : `${formatToString({ formatString, value: from })}〜${formatToString({ formatString, value: to })}`;
        return [
            {
                description: '関連する知見・実績を持つコンサルタントからメッセージが届きます。',
                title: `相談オファーが届く\n（${formatToString({ formatString, value: requestDeadlineAt })}まで）`,
            },
            {
                description: 'チャットでのすり合わせを通じて相談するコンサルタントを決め、日程を調整します。',
                title: '相談日程を調整する',
            },
            {
                description: 'PROFFITのサイト上でWeb会議に参加し、コンサルタントと相談を実施します。',
                title: `オンラインで相談する\n（${interviewRequestedAt}頃）`,
            },
        ];
    },
    /**
     * 相談オファーの説明文言
     */
    offerDescription: () => [
        {
            description: 'チャットでのやり取りを通じて、アドバイスしてもらえる内容やディスカッションのイメージを膨らませましょう。',
            title: 'アドバイスしてもらえる内容を確認しましょう。',
        },
        {
            description: '相談したいコンサルタントが決まったら、日程を調整して申し込みを確定しましょう。\n※相談を見送るコンサルタントに対しても「キャンセル」確定の操作が必要です。',
            title: '相談日程を調整しましょう。',
        },
    ],
};
